import { Duration } from '@chaos/types';

export const DurationValues: Duration[] = [
  { blocksCount: 250, duration: 3600, name: '1 Hour' },
  { blocksCount: 1000, duration: 14400, name: '4 Hours' },
  { blocksCount: 3000, duration: 43200, name: '12 Hours' },
  { blocksCount: 6000, duration: 86400, name: '1 Day' },
  { blocksCount: 42000, duration: 604800, name: '1 Week' },
];
